export default {
  buttons: {
    send_code: 'Send loginkode',
  },
  placeholders: {
    mobile_number: 'Mobilnummer',
    email: 'E-mailadresse',
  },
  feedback: {
    phone_number_required: 'Indtast dit telefonnummer',
    email_required: 'Indtast din e-mailadresse',
  },
};
